const UOBConfigLinePatternRe = /(?<key>[^:]*)?:(?<name>[^:]*)?(:\((?<params>.*)\))?$/gm
const UOBConfigLineParamPatterRe = /(?<key>[a-zA-Z][a-zA-Z0-9]*)\s*:\s*(?<value>[^|]+)/g
const UOBConfigOptionTypePatternReMap = {
  text: { pattern: /^text$/ },
  select: {
    pattern: /select\((.+)?\)/,
    fn: (value) => {
      const items = []
      for (const item of value.matchAll(/((?<key>[a-zA-Z0-9]+)?:(?<name>[^,)]+))/g)) {
        items.push({
          key: item.groups.key,
          name: item.groups.name
        })
      }
      return {
        type: 'select',
        items
      }
    }
  }
}

const UOBParser = {
  cleanLineBreak (text) {
    const parsed1 = text.replace(/\n|\r/gm, '\n').split('\n')

    let lines = []
    let currentLine = ''
    let currentOpenParen = 0
    let currentCloseParen = 0
    for (const line of parsed1) {
      currentOpenParen += (line.match(/\(/g) || []).length
      currentCloseParen += (line.match(/\)/g) || []).length
      currentLine += line
      if (currentOpenParen === currentCloseParen) {
        lines.push(currentLine)
        currentLine = ''
        currentOpenParen = 0
        currentCloseParen = 0
      }
    }

    return lines
  },
  parsePlaceOptionParams (text) {
    if (!text) {
      return null
    }
    const matched = text.matchAll(UOBConfigLineParamPatterRe)
    if (!matched) {
      return null
    }
    const params = {}
    for (const match of matched) {
      const key = match.groups.key
      const value = match.groups.value

      let newValue = value

      switch (key) {
        case 'optionType':
          const matchedKey = Object.keys(UOBConfigOptionTypePatternReMap).find((key) => {
            const pattern = UOBConfigOptionTypePatternReMap[key]
            if (pattern) {
              return pattern.pattern.test(value)
            }
          })
          if (matchedKey && UOBConfigOptionTypePatternReMap[matchedKey].fn) {
            newValue = UOBConfigOptionTypePatternReMap[matchedKey].fn(value)
          } else if (matchedKey) {
            newValue = { type: matchedKey }
          }
          break
      }

      params[key] = newValue
    }
    return params
  },
  parsePlaceOption (text) {
    const lines = this.cleanLineBreak(text)

    const matched = lines
      .join('\n')
      .matchAll(UOBConfigLinePatternRe)
    const conf = []
    for (const match of matched) {
      conf.push({
        key: match.groups.key ? match.groups.key.trim() || null : null,
        name: match.groups.name.trim(),
        params: this.parsePlaceOptionParams(match.groups.params)
      })
    }

    return conf
  }
}

export default {
  uob: UOBParser
}



// WEBPACK FOOTER //
// ./src/parser.js